export default {
  app: {
    languagePopup: {
      title: 'Momentálne sa nachádzate na anglickej verzii {logo}',
      subtitle: 'Chcete prepnúť na preferovaný jazyk?',
      cta: 'Prepnúť na {lang}',
    },
  },
};
